import type {
    Segment,
    TargetSegmentPickerDimensionProps,
} from "../../components/dimensions/vitest/TargetSegmentPickerDimension";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const segmentFixture: Segment = {
    id: "2308382",
    name: "Twitch - Spanish Viewers",
    category: "Advertiser Audience",
    description:
        "Twitch viewers who have watched content from Spanish channels",
    marketplaces: ["7", "771770", "526970", "1"],
    positiveTargetGroups: null,
    negativeTargetGroups: null,
    creationTime: 1683041810416,
    accessStatus: null,
    dataProviderId: null,
    channel: "O5XOUMPE",
};

export const basicTargetSegmentPicker: TargetSegmentPickerDimensionProps = {
    id: "targetSegmentPicker",
    type: DimensionTypes.TARGET_SEGMENT_PICKER,
    configuration: {
        label: "Target Segment Picker",
        tooltip: "tooltip",
        rodeoIdDimension: "rodeo_id",
        marketplaceIdDimension: "marketplace_id",
    },
    dependencies: ["rodeo_id", "marketplace_id"],
};
export const targetSegmentPickerDimensionExample: DimensionFixtureExample = {
    id: "tsp",
    name: "Target Segment Picker",
    description: "Target Segment Picker",
    dimensions: [
        [
            {
                id: "marketplace_id",
                type: "input",
                dependencies: [],
                configuration: {
                    label: "marketplace id",
                },
            } as any,
            {
                id: "rodeo_id",
                type: "input",
                dependencies: [],
                configuration: {
                    label: "rodeo id",
                },
            } as any,
            basicTargetSegmentPicker,
        ],
    ],
};
